export default [
  {
    title: 'Clients',
    route: 'clients',
    icon: 'UsersIcon',
  },
]

